import { useState } from 'react';

/**
 * Provides a hook for a component to manage a "loading" state. It returns the state and
 * a function to wrap a promise during which the component is loading.
 *
 *     const [loading, withLoadingState] = useLoadingState();
 *
 */
export default function useLoadingState(): [
  boolean,
  (callback: () => Promise<void>) => Promise<void>
] {
  const [loading, setLoading] = useState(false);

  /**
   * This function can be called by a component to set `{ loading: true }` just for the duration
   * of the asynchronous callback.
   */
  async function withLoadingState(callback: () => Promise<void>) {
    if (!loading) {
      setLoading(true);
      try {
        await callback();
      } finally {
        setLoading(false);
      }
    }
  }

  return [loading, withLoadingState];
}
